import dayjs from "dayjs-ext";

export interface TimeConfigParams {
  periodInSeconds: number;
  intervalInSeconds: number;
  fromInMs?: number;
  toInMs?: number;
}

export class ChartInterval {
  constructor(public seconds: number) {}

  get milliseconds(): number {
    return this.seconds * 1000;
  }
}

export interface TimeConfig {
  fromDate: number;
  toDate: number;
  interval: ChartInterval;
}

export class TimeUtils {
  static readonly MINUTE = 60;
  static readonly HOUR = TimeUtils.MINUTE * 60;
  static readonly DAY = TimeUtils.HOUR * 24;
  static readonly WEEK = TimeUtils.DAY * 7;
  static readonly MONTH = TimeUtils.DAY * 31;
  static readonly YEAR = TimeUtils.MONTH * 12;

  static createConfig(periodInSeconds: number, intervalInSeconds: number, toDateInMs?: number): TimeConfig {
    const period = Math.max(TimeUtils.HOUR, Math.round(periodInSeconds / intervalInSeconds) * intervalInSeconds);
    let toDate;
    if (toDateInMs) {
      toDate = dayjs(toDateInMs);
    } else {
      toDate = dayjs().startOf("hour");
    }
    toDate = toDate.subtract(10, "minute");

    const fromDate = toDate.subtract(period, "second").valueOf();
    return {
      fromDate,
      toDate: toDate.valueOf(),
      interval: new ChartInterval(intervalInSeconds),
    };
  }

  static getBinIntervalForPeriod = (periodInSeconds: number, minInterval?: number) => {
    let interval = TimeUtils.HOUR * 6;

    if (periodInSeconds <= TimeUtils.HOUR * 12) {
      interval = TimeUtils.MINUTE;
    }

    if (periodInSeconds > TimeUtils.HOUR * 12 && periodInSeconds <= TimeUtils.DAY) {
      interval = TimeUtils.MINUTE * 5;
    }

    if (periodInSeconds > TimeUtils.DAY && periodInSeconds <= TimeUtils.WEEK) {
      interval = TimeUtils.MINUTE * 15;
    }

    if (periodInSeconds > TimeUtils.WEEK && periodInSeconds <= TimeUtils.WEEK * 2) {
      interval = TimeUtils.MINUTE * 30;
    }

    if (periodInSeconds > TimeUtils.WEEK * 2 && periodInSeconds <= TimeUtils.MONTH) {
      interval = TimeUtils.HOUR;
    }

    if (periodInSeconds > TimeUtils.MONTH && periodInSeconds <= TimeUtils.YEAR) {
      interval = TimeUtils.HOUR * 2;
    }

    return minInterval !== undefined ? Math.max(interval, minInterval) : interval;
  };

  static parseHour = (dateValue: number) => {
    const d = dayjs(dateValue);
    const hour = d.hour() >= 10 ? d.hour() : "0" + d.hour(),
      minutes = d.minute() >= 10 ? d.minute() : "0" + d.minute();
    return `${hour}:${minutes}`;
  };

  static parseDate = (dateValue: number) => {
    const d = dayjs(dateValue);
    const day = TimeUtils.parseDay(d.day());
    return `${day} ${d.date()}/${d.month() + 1}/${d.year()}`;
  };

  static parseDay = (dayIndex: number) => {
    const week = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    return week[dayIndex];
  };

  static parseMonth = (monthIndex: number) => {
    const year = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    return year[monthIndex];
  };

  static sleep = (millisecond: number) => {
    return new Promise(resolve => setTimeout(resolve, millisecond));
  };
}



// WEBPACK FOOTER //
// ./app/utils/timeUtils.ts